import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.705 7.92 13.37 6.253a.67.67 0 0 0-.52-.253h-4V2a.667.667 0 0 0-1.333 0v.667h-4a.67.67 0 0 0-.52.253L1.664 4.587a.67.67 0 0 0 0 .826L2.998 7.08a.67.67 0 0 0 .52.253h4v6H6.184a.667.667 0 1 0 0 1.334h4a.667.667 0 0 0 0-1.334H8.852v-2.666h4a.67.67 0 0 0 .52-.254l1.333-1.666a.67.67 0 0 0 0-.827M7.517 6h-3.68l-.8-1 .8-1h3.68zm5.013 3.333h-3.68v-2h3.68l.8 1z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })